export const SCREENS = {
  TITLE: 0,
  LEVEL: 1,
  LOSE: 2,
  WIN: 3,
}